import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/_typography.css';
import './styles/index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { initPartner } from './partner/initPartner';

// Run once before React renders anything
initPartner();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <App />
  </React.StrictMode>
);

reportWebVitals();
